<template>
  <div ref="poster" class='rank-template'>
    <div class="header">
      <img class="banner" :src="rankingDetails?.brandImage" alt="">
      <span v-if="rankingDetails.details" class="btn" @click="handleShowDetail">活动详情</span>
    </div>
    <div class="content">
      <div class="tab">
        <div class="active-tab">
          <span class="name" @click="handleShowTabList">{{ activeTabName }}</span>
        </div>
        <div class="tab-list" :class="{'tab-list-show': showTabList}">
          <p class="label">切换分类</p>
          <div class="tab-content">
            <div v-for="(item, index) in rankingDetails?.hotListClassifications" :key="index" class="tab-item" :class="{'active': item.signatureText === activeTabName}" @click="handleTabClick(item)">
              <span class="name">{{ item.optionText }}</span>
            </div>
          </div>
        </div>
        <div class="mask" :class="{'mask-show': showTabList}" @click="handleShowTabList"></div>
      </div>
      <div class="list" @scroll="handleScroll" ref="listContainer">
        <div v-for="(item, index) in listData" :key="index" class="list-item">
          <div class="left">
            <span class="num" :class="{'num1': index === 0, 'num2': index === 1, 'num3': index === 2}">{{ index + 1 }}</span>
          </div>
          <div class="right">
            <span class="title">{{ item.name }}</span>
            <div class="heat">
              <span class="icon" :style="{ backgroundImage: `url(${rankingDetails.numericalIcon})`, backgroundSize: '100% 100%' }"></span>
              <span class="text">{{ rankingDetails.numericalText ? item.heat + rankingDetails.numericalText : item.heat }}</span>
            </div>
          </div>
        </div>
        <div v-if="listData.length === 0 && !loadingMore" class="no-data">
          <p class="no-data-text">暂无数据</p>
        </div>
        <p v-if="loadingMore" class="loading-more">加载中...</p>
        <p v-if="listData.length && !hasMore && !loadingMore" class="no-more">没有更多数据了</p>
        <p v-if="!hasMore && !loadingMore" class="footer">技术支持：南方智媒科技</p>
      </div>
    </div>
    <transition name="faded">
      <div data-html2canvas-ignore class="detail-overlay" v-if="showDetail" @click.self="handleHideDetail">
        <div class="detail-body">
          <div class="detail-title">活动详情</div>
          <div class="detail-content">{{ rankingDetails.details }}</div>
          <img @click.stop="handleHideDetail" class="popup-close-icon" src="../assets/icon_delete.png" alt="关闭弹窗">
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { getHotListData } from '@/api'
import getUrlParams from '@/utils/getUrlParams'
import html2canvas from 'html2canvas'
import { imgUrlToBase64, loadImg } from '@/utils/base64'
export default {
  name: 'RankTemplate',
  props: {
    rankingDetails: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    rankId () {
      const { id } = getUrlParams()
      return id
    },
  },
  data () {
    return {
      showDetail: false,
      activeTabName: this.rankingDetails?.hotListClassifications[0].signatureText || '',
      classificationId: this.rankingDetails?.hotListClassifications[0].id || '',
      pageQuery: {
        page: 0,
        size: 20,
      },
      listData: [],
      showTabList: false,
      hasMore: true,
      loadingMore: false,
      scrollLock: false,
    }
  },
  async created () {
    await this.fetchRankData()
    window.parent.postMessage({ type: 'pageInit' }, '*')
  },
  mounted () {
    window.addEventListener('message', (e) => {
      if (e.data.type !== 'poster') {
        return
      }
      this.$nextTick(() => {
        this.generatePoster()
      })
    })
  },
  methods: {
    handleShowDetail () {
      this.showDetail = true
    },
    handleHideDetail () {
      this.showDetail = false
    },
    async fetchRankData (isLoadMore = false) {
      if (!this.classificationId) {
        this.classificationId = this.rankingDetails?.hotListClassifications[0].id
      }
      if (isLoadMore) {
        this.loadingMore = true
        this.pageQuery.page += 1
      } else {
        this.pageQuery.page = 0
        this.listData = []
        this.hasMore = true
      }
      const res = await getHotListData({
        rankId: this.rankId,
        classificationId: this.classificationId,
        ...this.pageQuery,
      })
      if (res.code === 200) {
        if (isLoadMore) {
          this.listData = [...this.listData, ...res.data.content]
        } else {
          this.listData = res.data.content
        }
        // 检查是否还有更多数据
        this.hasMore = !res.data.last
        this.loadingMore = false
        this.scrollLock = false
      }
    },
    handleShowTabList () {
      this.showTabList = !this.showTabList
    },
    handleTabClick (item) {
      this.activeTabName = item.signatureText
      this.classificationId = item.id
      this.showTabList = false
      this.loadingMore = true
      this.fetchRankData(false)
    },
    handleScroll (event) {
      if (this.scrollLock || this.loadingMore || !this.hasMore) return
      const container = event.target
      const scrollTop = container.scrollTop
      const scrollHeight = container.scrollHeight
      const clientHeight = container.clientHeight
      // 距离底部50px时触发加载更多
      if (scrollHeight - scrollTop - clientHeight < 50) {
        this.scrollLock = true
        this.fetchRankData(true)
      }
    },
    async generatePoster () {
      const { brandImage, shareQrcode } = this.rankingDetails
      this.rankingDetails.brandImage = await imgUrlToBase64({ url: brandImage })
      this.rankingDetails.shareQrcode = await imgUrlToBase64({ url: shareQrcode })
      const dom = this.$refs.poster
      const width = window.innerWidth; const height = window.innerHeight
      html2canvas(dom, {
        scrollX: 0,
        scrollY: 0,
        scale: 2,
        width,
        height,
        backgroundColor: '#fff',
        imageTimeout: 0,
        useCORS: true,
        allowTaint: true,
      }).then(async canvas => {
        const pic = await this.drawShareQrCode(canvas, this.rankingDetails.shareQrcode, width, height)
        window.parent.postMessage({ type: 'posterBase64Img', data: pic }, '*')
      })
    },
    async drawShareQrCode (canvas, shareQrcode, width, height) {
      const ctx = canvas.getContext('2d')
      const imgW = 86; const imgH = 86
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, height - 100, width, height)
      const shareQrCodeImg = await loadImg(shareQrcode)
      ctx.drawImage(shareQrCodeImg, width / 2 - imgW / 2, height - 100 + (100 - imgH) / 2, imgW, imgH)
      return canvas.toDataURL('image/jpeg', 1)
    },
  },
}
</script>

<style lang="less" scoped>
.rank-template {
  .header {
    width: 100%;
    height: 2.11rem;
    position: relative;
    img.banner {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
    .btn{
      width: 0.2rem;
      height: 0.58rem;
      position: absolute;
      top: 0.2rem;
      right: 0;
      font-size: 0.11rem;
      line-height: 0.13rem;
      color: #fff;
      text-align: center;
      padding: 0.08rem 0.02rem 0;
      background: rgba(0,0,0,0.60);
      border-radius: 0.08rem 0px 0px 0.08rem;
    }

  }
}
.detail-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .5);
}

.detail-body {
  position: fixed;
  top: 44.4%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  background: #ffffff;
  width: 3.2rem;
  height: 3.45rem;
  padding: 0.2rem 0.1rem;
  border-radius: 0.1rem;
}

.detail-title {
  font-size: 0.18rem;
  color: #333333;
  line-height: 0.25rem;
  text-align: center;
}

.detail-content {
  margin-top: 0.1rem;
  padding: 0 0.15rem;
  font-size: 0.15rem;
  line-height: 0.21rem;
  color: #666666;
  overflow-y: scroll;
  height: 2.75rem;
  white-space: pre-wrap;
}
::-webkit-scrollbar-thumb {
  width: 0.06rem;
  height: 0.25rem;
  background-color: #E9E9E9;
  border-radius: 0.05rem;
}

.popup-close-icon {
  width: 0.24rem;
  height: 0.24rem;
  position: absolute;
  bottom: -0.1rem;
  left: 50%;
  transform: translateX(-50%) translateY(100%);
}
.content{
  background: #ffffff;
  border-radius: 0.1rem 0.1rem 0 0;
  position: relative;
  margin-top: -0.08rem;
  .tab{
    position: relative;
    .active-tab {
      line-height: 0.42rem;
      font-size: 0.18rem;
      text-align: center;
      .name{
        display: inline-block;
        line-height: 0.42rem;
        font-size: 0.18rem;
        position: relative;
        max-width: 3rem;
        &::before{
          content: '';
          width: 0.12rem;
          height: 0.03rem;
          background: #FF6B6B;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          border-radius: 0.02rem;
        }
        &::after{
          content: '▼';
          position: absolute;
          top: 50%;
          right: -0.12rem;
          transform: translateY(-50%);
          font-size: 0.06rem;
          line-height: 0.42rem;
          margin-left: 0.05rem;
          color: #666;
        }
      }
    }
    .tab-list{
      width: 100%;
      position: absolute;
      top: 100%;
      left: 0;
      padding: 0.15rem;
      background: #f7f7f7;
      z-index: 9;
      display: none;
      .label{
        font-size: 0.15rem;
        color: #999999;
      }
      .tab-content{
        display: flex;
        flex-wrap: wrap;
      }
      .tab-item{
        flex: none;
        width:0.81rem;
        height: 0.36rem;
        line-height: 0.36rem;
        font-size: 0.15rem;
        color: #666;
        text-align: center;
        background: #fff;
        border-radius: 0.04rem;
        border: 1px solid rgba(238,238,238,1);
        margin: 0.05rem 0.07rem 0 0;
        .name {
          padding: 0 0.02rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          display: block;
        }
        &:nth-child(4n){
          margin-right: 0;
        }
        &.active{
          color: #FF6B6B;
        }
      }
    }
    .tab-list-show{
      display: block;
    }
    .mask{
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      height: 110vh;
      z-index: 8;
      display: none;
      background: rgba(0, 0, 0, 0.5);
    }
    .mask-show{
      display: block;
    }
  }
  .list{
    height: calc(100vh - 2.45rem);
    min-height: 3.16rem;
    overflow-y: auto;
    .no-data {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 3.1rem;
      padding: 1rem 0;
      text-align: center;
      .no-data-text {
        font-size: 0.16rem;
        color: #999;
        line-height: 0.22rem;
      }
    }
    .list-item{
      display: flex;
      padding: 0.12rem 0.14rem 0 0.1rem;
      .left{
        flex: none;
        width: 0.24rem;
        margin-right: 0.06rem;
        .num{
          display: block;
          width: 0.24rem;
          height: 0.24rem;
          text-align: center;
          line-height: 0.24rem;
          font-size: 0.14rem;
          color: #999;
        }
        .num1 {
          background: url(../assets/icon_top1.png) no-repeat center center;
          background-size: 100% 100%;
          font-size: 0;
        }
        .num2 {
          background: url(../assets/icon_top2.png) no-repeat center center;
          background-size: 100% 100%;
          font-size: 0;
        }
        .num3 {
          background: url(../assets/icon_top3.png) no-repeat center center;
          background-size: 100% 100%;
          font-size: 0;
        }
      }
      .right{
        flex: 1;
        padding: 0 0 0.16rem 0;
        border-bottom: 1px solid #ebebeb;
        .title{
          display: block;
          font-size: 0.18rem;
          line-height: 0.26rem;
          font-weight: 400;
          color: #333333;
        }
        .heat{
          position: relative;
          margin-top: 0.08rem;
          display: flex;
          align-items: center;
          .icon {
            flex: none;
            display: inline-block;
            width: 0.16rem;
            height: 0.16rem;
            margin-right: 0.02rem;
          }
          .text{
            width: 3rem;
            display: inline-block;
            font-size: 0.12rem;
            color: #999999;
            line-height: 0.13rem;
            height: 0.13rem;
            font-weight: 400;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
    }
    .loading-more, .no-more{
      font-size: 0.12rem;
      color: rgba(0,0,0,0.30);
      font-weight: 400;
      text-align: center;
      margin-top: 0.12rem
    }
  }
}
.footer{
  padding: 0.2rem 0 0.34rem;
  font-size: 0.12rem;
  color: rgba(0,0,0,0.30);
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}
</style>
